import store from "../store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore"; // esto es para la base de datos
import "firebase/storage"; // esto es para el storage
import router from "../routes";
import apiServices from "@/services/yungol-services";
import io from "socket.io-client";

const socket = io(process.env.SOCKET_URL);
// const socket = io('https://apinew.cincel.com.co');

// cincel produccion
const config = {
  apiKey: "AIzaSyC3ttFGx6NkVpSw_U6kpfqW_0eOke6S4ME",
  authDomain: "cincel-83343.firebaseapp.com",
  databaseURL: "https://cincel-83343.firebaseio.com",
  projectId: "cincel-83343",
  storageBucket: "cincel-83343.appspot.com",
  messagingSenderId: "155399002665",
  appId: "1:155399002665:web:16cdc4b672b58fa0",
};

export default {
  install: (Vue, options) => {
    firebase.initializeApp(config);
    const auth = firebase.auth();
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithEmailAndPassword(username, pass);
      },
      loginGoogle: async () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithPopup(provider);
      },
      logout: async () => {
        await auth.signOut();
        store.commit("restartStore");
      },
      sendPasswordResetEmail: async (email) => {
        await auth.sendPasswordResetEmail(email, {
          url: "https://app.cincel.com.co",
        });
      },
    };
    Vue.prototype.$fire = {
      putimg: (file) => {
        return firebase
          .storage()
          .ref("images/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      reffile: (file) => {
        return firebase
          .storage()
          .ref("files/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      refexcel: (file) => {
        return firebase
          .storage()
          .ref("excel/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      reflideres: (file) => {
        return firebase
          .storage()
          .ref("lideres/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
    };
    auth.onAuthStateChanged((user) => {
      if (user) {
        localStorage.setItem("loggedin", "true");
        store.commit("refreshUser", user);
        store.commit("refreshAuth");
        user.getIdToken().then(
          (idtoken) => {
            store.commit("decodeToken", idtoken);
            if (
              store.state.tokenUser.admin ||
              store.state.tokenUser.cliente ||
              store.state.tokenUser.frs ||
              store.state.tokenUser.lider ||
              store.state.tokenUser.liderl ||
              store.state.tokenUser.ghumana ||
              store.state.tokenUser.cmt
            ) {
              store.commit("refreshAuth");
              apiServices
                .get(`/empresacredential`, {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                  },
                })
                .then((empresa) => {
                  store.commit("refreshEmpresa", empresa.data);
                });
              socket.on(user.uid, function(msg) {
                if (msg.empresa) {
                  store.commit("refreshAuth");
                  apiServices
                    .get(`/empresacredential`, {
                      headers: {
                        Authorization: "Bearer " + idtoken,
                      },
                    })
                    .then((empresa) => {
                      store.commit("refreshEmpresa", empresa.data);
                    });
                }
              });
            } else {
              localStorage.removeItem("loggedin");
              store.commit("restartStore");
              router.replace({
                name: "logout",
              });
            }
          },
          (error) => {
            store.commit("restartStore");
            console.log(error);
          }
        );
      } else {
        localStorage.removeItem("loggedin");
        store.commit("restartStore");
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/firebase/index.js